import { render, staticRenderFns } from "./BulkMessageInformation.vue?vue&type=template&id=55f0f278&scoped=true"
import script from "./BulkMessageInformation.vue?vue&type=script&lang=js"
export * from "./BulkMessageInformation.vue?vue&type=script&lang=js"
import style0 from "./BulkMessageInformation.vue?vue&type=style&index=0&id=55f0f278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f0f278",
  null
  
)

export default component.exports